const RnF = () => {
    return (
    <div>
      <h1>Album List Manager App Review and Feedback.</h1>
      <p style = {{color: 'blue', fontWeight: 'bold'}}>All the users of this Web App are requested to share their experience and feedback after using this App. Also share the problems as well as any suggestions for improvement using the Share Feedback Button below.</p>
      <div style = {{display: 'flex', justifyContent : 'center'}}>
        <a href = "https://forms.gle/TMAe4rh5oA3Ead7d9"> <button style = {{borderRadius: "1%", backgroundColor: 'orange', color: 'brown', fontWeight: 'bold',  cursor: 'crosshair'}}>Share Feedback</button></a>  
      </div>
      <br />
      <br />
      <br />
      <br />   
      <h2 style = {{textAlign: 'center'}}>----------x---------- END OF REVIEW & FEEDBACK PAGE ----------x----------</h2> 
    </div>
  );
};

export default RnF;